// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.cAAAs{flex:1;display:flex;flex-direction:column;border-radius:8px;min-height:0;overflow:hidden;box-shadow:none}.CaNl2{flex:1;min-height:0;overflow:hidden;position:relative}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"card": `cAAAs`,
	"content": `CaNl2`
};
export default ___CSS_LOADER_EXPORT___;
